import { CANDIDATE_TAGS, INIT_COMPETENCY_LEVEL } from 'domain/shared/newVacancy/constants';

export enum SourcingSearchMode {
  STRICT = 'STRICT',
  NON_STRICT = 'NON_STRICT',
}

export type SourcingCompetencyLevel = 'L0' | keyof typeof INIT_COMPETENCY_LEVEL;

export type SourcingCandidateTag = keyof typeof CANDIDATE_TAGS;
